import qs from 'qs';
import client from './client';

const orderUrl = '/api/v1/project/orders'; 

//수주된 프로젝트 가져오기
export const getProjectOrderHistory = (id) => {
  return client.get(`${orderUrl}/list/${id}`);
};

// 수주품의서 삭제(소프트, ORD_YN='N'). 발행 완료된 세금계산서가 남아있으면 서버가 거부한다 -
// 권한자 일괄 취소(billCancel.bulkCancelOrder)를 먼저 해야 한다. bito 신설(2026-10-21).
export const deleteOrderContract = (roUuid) => {
  return client.delete(`${orderUrl}/contract/data/${roUuid}`);
};

